import http from '../../../Utils/http';
import responseMessageHandler from '../../../Utils/ResponseMessageHandler';

const UpdateLocation = {
  name: 'updateLocation',
  state: {
    data: {},
    loading: false,
    error: '',
  },
  reducers: {
    updateRequested(state) {
      return {
        ...state,
        loading: true,
        error: '',
      };
    },

    updateSucceeded(state, payload) {
      return {
        ...state,
        data: payload,
        loading: false,
        error: '',
      };
    },

    updateFailed(state, payload) {
      return {
        ...state,
        error: payload,
        loading: false,
      };
    },
  },
  effects: (dispatch) => ({
    async updateExistingLocation({ locationId, address, location_name, latitude, longitude, schedule}) {
      try {
        const payload = {
          address,
          location_name,
          location: {
            latitude: latitude,
            longitude: longitude,
          },
          schedule
        };

        this.updateRequested();

        const response = await http.put(`savvy/locations/${locationId}`, payload);
        this.updateSucceeded(response.data);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'success',
            message: 'Location updated successfully!',
            show: true,
          },
        });
      } catch (error) {
        this.updateFailed(error.message);

        dispatch({
          type: 'helper/show',
          payload: {
            type: 'error',
            message: responseMessageHandler.show(error.message),
            show: true,
          },
        });
      }
    },
  }),
};

export default UpdateLocation;
